import { loadAndShowModal, loadModal } from '../actions/loadModal';

const INFO_MODAL_HASH = '#info';
const INFO_MODAL_ID = 'growtypeChatInfoModal';
const INFO_MODAL_TAB_TARGET_PREFIX = 'chat-info-modal-';
let infoModalOpenPromise = null;

function getInfoModalTabTargetFromHash() {
    return window.growtypeTabs?.getTargetByPrefix(INFO_MODAL_TAB_TARGET_PREFIX) || '';
}

function isInfoModalHash() {
    return (window.location.hash || '').toLowerCase() === INFO_MODAL_HASH
        || getInfoModalTabTargetFromHash() !== '';
}

function updateInfoModalHash() {
    if (isInfoModalHash()) {
        return;
    }

    const url = `${window.location.pathname}${window.location.search}${INFO_MODAL_HASH}`;
    window.history.replaceState(window.history.state, document.title, url);
}

function clearInfoModalHash() {
    if (!isInfoModalHash()) {
        return;
    }

    if ((window.location.hash || '').toLowerCase() === INFO_MODAL_HASH) {
        const url = `${window.location.pathname}${window.location.search}`;
        window.history.replaceState(window.history.state, document.title, url);
        return;
    }

    window.growtypeTabs?.removeTargetsByPrefix(INFO_MODAL_TAB_TARGET_PREFIX);
}

function activateInfoModalTabFromHash() {
    window.growtypeTabs?.activateFromHash();
}

function openInfoModal() {
    updateInfoModalHash();

    const modal = document.getElementById(INFO_MODAL_ID);
    if (modal?.classList.contains('show')) {
        return Promise.resolve($(modal));
    }

    if (infoModalOpenPromise) {
        return infoModalOpenPromise;
    }

    infoModalOpenPromise = loadAndShowModal(
        growtype_chat_ajax.get_info_modal_action,
        INFO_MODAL_ID,
        activateInfoModalTabFromHash
    )
        .catch(function () {
            clearInfoModalHash();
        })
        .finally(function () {
            infoModalOpenPromise = null;
        });

    return infoModalOpenPromise;
}

export function infoModal() {
    $(document)
        .off('click.growtypeChatInfoModal', '[data-growtype-chat-info-modal-trigger="true"]')
        .on('click.growtypeChatInfoModal', '[data-growtype-chat-info-modal-trigger="true"]', function (event) {
            event.preventDefault();
            openInfoModal();
        })
        .off('hidden.bs.modal.growtypeChatInfoModal', `#${INFO_MODAL_ID}`)
        .on('hidden.bs.modal.growtypeChatInfoModal', `#${INFO_MODAL_ID}`, clearInfoModalHash);

    $(document).on('click', '.g-chat-level[data-type="modal"]', function () {
        const sessionToken = $(this).closest('[data-session-token]').attr('data-session-token')
            || $('.g-chatform').first().attr('data-session-token')
            || '';

        loadModal(
            growtype_chat_ajax.get_chat_level_modal_action,
            function ($modal) {
                $modal.modal('show');
            },
            {
                modalSelector: '.modal-chat-level-explanation',
                ajaxData: { token: sessionToken },
            }
        );
    });

    if (isInfoModalHash()) {
        openInfoModal();
    }
}
